export const categories = [
  { slug: 'yingshi', name: '影视资源', icon: 'ri-movie-2-line', description: '最新电影、电视剧、综艺磁力资源网站收录', count: 128 },
  { slug: 'ruanjian', name: '软件工具', icon: 'ri-apps-2-line', description: '各类软件、系统工具、办公软件磁力下载导航', count: 96 },
  { slug: 'youxi', name: '游戏天地', icon: 'ri-gamepad-line', description: '单机游戏、网络游戏、主机游戏磁力资源汇总', count: 87 },
  { slug: 'yinyue', name: '音乐音效', icon: 'ri-music-2-line', description: '无损音乐、专辑合集、音效素材磁力链接推荐', count: 64 },
  { slug: 'xuexi', name: '学习教程', icon: 'ri-book-open-line', description: '编程课程、设计教程、考试资料磁力资源导航', count: 73 },
  { slug: 'dongman', name: '动漫番剧', icon: 'ri-emotion-line', description: '日漫、国漫、美漫磁力资源网站一站收录', count: 55 },
  { slug: 'zongyi', name: '综艺纪录', icon: 'ri-tv-2-line', description: '热门综艺、纪录片、真人秀磁力资源推荐', count: 42 },
  { slug: 'ziliao', name: '文档资料', icon: 'ri-file-text-line', description: '电子书、论文、期刊、杂志磁力下载网站', count: 38 },
];

export const getCategoryBySlug = (slug: string) => categories.find(c => c.slug === slug);